class PredictiveSearch extends HTMLElement {
	constructor() {
		super()

		this.input = this.querySelector('input[type="search"]')
		this.predictiveSearchResults = this.querySelector(
			'#predictive-search-results'
		)

		this.clearBtn = this.querySelector('[data-clear-search]')
		this.submitBtn = this.querySelector('[data-submit]')

		this.input.addEventListener(
			'input',
			this.debounce((event) => {
				this.onChange(event)
			}, 300).bind(this)
		)
		this.clearBtn.addEventListener('click', (e) => {
			e.preventDefault()

			this.clearBtn.classList.add('hidden')
			this.submitBtn.classList.remove('hidden')
			this.input.value = ''
			this.input.focus()
		})
	}

	onChange() {
		const searchTerm = this.input.value.trim()
		if (!searchTerm.length) {
			return
		}

		this.clearBtn.classList.remove('hidden')
		this.submitBtn.classList.add('hidden')

		this.getSearchResults(searchTerm)
	}

	getSearchResults(searchTerm) {
		fetch(
			`/search/suggest?q=${searchTerm}&section_id=predictive-search&resources[type]=product,article,page`
		)
			.then((response) => {
				if (!response.ok) {
					throw new Error(response.status)
				}
				return response.text()
			})
			.then((text) => {
				const resultsMarkup = new DOMParser()
					.parseFromString(text, 'text/html')
					.querySelector('#shopify-section-predictive-search').innerHTML
				this.predictiveSearchResults.innerHTML = resultsMarkup
				initSearchSwiper()
			})
			.catch((error) => {
				throw error
			})
	}

	debounce(fn, wait) {
		let t
		return (...args) => {
			clearTimeout(t)
			t = setTimeout(() => fn.apply(this, args), wait)
		}
	}
}

customElements.define('predictive-search', PredictiveSearch)
